import React, { useContext, useEffect, useMemo } from "react";
import {
  SourceTopicContext,
  SourceTopicContextType,
} from "./SourceTopicContext";
import findIndex from "lodash/findIndex";
import { ISourceTopicFields } from "src/types/generated/contentful";

const SourceTopic = (data: ISourceTopicFields) => {
  const { url, internalName } = data;
  const { sources, saveSource } = React.useContext(
    SourceTopicContext
  ) as SourceTopicContextType;

  let index =
    findIndex(sources, function (o) {
      return o.url === url;
    }) + 1;

  useEffect(() => {
    saveSource(data);
  }, [data]);

  return (
    <>
      <sup>
        <a href="#sources">{index}</a>
      </sup>
    </>
  );
};

export default React.memo(SourceTopic);
